/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DoseTimingResponseConceptGroup
 */
export interface DoseTimingResponseConceptGroup {
    /**
     * 
     * @type {number}
     * @memberof DoseTimingResponseConceptGroup
     */
    conceptGroupId?: number;
}

/**
 * Check if a given object implements the DoseTimingResponseConceptGroup interface.
 */
export function instanceOfDoseTimingResponseConceptGroup(value: object): value is DoseTimingResponseConceptGroup {
    return true;
}

export function DoseTimingResponseConceptGroupFromJSON(json: any): DoseTimingResponseConceptGroup {
    return DoseTimingResponseConceptGroupFromJSONTyped(json, false);
}

export function DoseTimingResponseConceptGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoseTimingResponseConceptGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'conceptGroupId': json['conceptGroupId'] == null ? undefined : json['conceptGroupId'],
    };
}

export function DoseTimingResponseConceptGroupToJSON(json: any): DoseTimingResponseConceptGroup {
    return DoseTimingResponseConceptGroupToJSONTyped(json, false);
}

export function DoseTimingResponseConceptGroupToJSONTyped(value?: DoseTimingResponseConceptGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conceptGroupId': value['conceptGroupId'],
    };
}

